import { render, staticRenderFns } from "./ServicePricing.vue?vue&type=template&id=1dd1614a&"
import script from "./ServicePricing.vue?vue&type=script&lang=js&"
export * from "./ServicePricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports